import React from 'react'
import { Edit } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import OrganizationForm from './OrganizationForm'

const OrganizationEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit>
        <OrganizationForm />
      </Edit>
    </SectionWrapper>
  )
}

export default OrganizationEdit
